import { render } from "./SponsorPage.vue?vue&type=template&id=5d6a2bbe"
import script from "./SponsorPage.vue?vue&type=script&lang=js"
export * from "./SponsorPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/armenium/56-free-school-street/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__